import Text from '@/atoms/Text/Text'
import cn from 'classnames'
import React from 'react'

function MarbleScore({ backgroundColor }) {
  const marbleScoreData = [
    {
      score: '10+',
      name: 'Decadent',
      description: 'This is the kind of Wagyu you’d leave to your kids. Incredibly rich, with complex intramuscular marbling that delivers a velvety mouthfeel you’ll remember long after the plate is clean. Rich with terroir and oozing luxuriousness, every bite of MBS 10+ Westholme Wagyu is a taste memory that will linger. '
    },
    {
      score: '8-9',
      name: 'Abundant',
      description: 'This is Wagyu reserved only for the best of friends and most special of occasions. Abundantly marbled cuts are melt-in-your-mouth tender with mouthwatering rivers of fat interwoven into every bite. MBS 8-9 Westholme Wagyu bursts with umami essence and is backed by the flavours of the open Australian rangeland.'
    },
    {
      score: '6-7',
      name: 'Ample',
      description: 'This is Wagyu full of flowing, even marbling throughout. Cuts with ample marbling are supple and indulgent, perfect for classic preparations yet flexible enough to bend the rules. MBS 6-7 Westholme Wagyu forms a perfect crust when seared, lending texture to an elegant interior.'
    },
    {
      score: '4-5',
      name: 'Balanced',
      description: 'This is Wagyu with a bit more beefiness. Balanced marbling gives each bite more texture and lends itself to toothsome bites and more intensive cooking processes, although it can stand on its own when treated with a simple sear. Despite its lower fat content, 5+ MBS Westholme Wagyu still puts a bit of elegance on the table.'
    },
  ]
  return (
    <div className={cn(
      "aaco-marble-score-bg bg-dark-warm-grey relative pt-9 pb-12", {
        [`bg-${backgroundColor}`]: backgroundColor !== undefined,
      }
    )}>
      <div className="aaco-marble-score-wrapper container my-0 mx-auto flex flex-col gap-y-6 md:gap-y-10">
        <div className="aaco-marble-score-header">
          <Text
            tag="h3"
            style="text-warm-grey"
          >
            Marble Score
          </Text>
          <hr className="border-warm-grey my-6" />
        </div>
        <div className="aaco-marble-score-content grid grid-cols-1 md:grid-cols-4 gap-x-16 gap-y-8 ">
          <div className="aaco-marble-score-content-left col-span-3 md:col-span-1">
            <Text
              tag="h6"
              style="text-warm-grey"
            >
              Westholme offers a range of marble scores across cuts and programs. Each offers a different eating experience and lends itself to different cooking methods. For those looking for more beefy flavour, explore Balanced and Ample grades. If you’re looking for a more fat-forward bite, treat your tastebuds to Abundant and Decadent grades.
            </Text>
          </div>
          <div className="aaco-marble-score-content-right col-span-3 grid">
            {marbleScoreData.map((data, index) => (
              <div key={index} className={`aaco-marble-score-content-detail grid grid-cols-5 md:grid-cols-8 pb-4 md:pb-8 lg:pb-12 border-b-1 border-warm-grey ${index !== 0 && "pt-4 md:pt-10"}`}>
                <div className="marble-score-number col-span-1 md:col-span-2 lg:col-span-1 self-start">
                  <h4
                    className="font-heading text-h6-mobile font-h6-mobile md:text-h4 md:font-h4 text-warm-grey"
                  >
                    {data.score}
                  </h4>
                </div>
                <div className="marble-content-score-detail grid lg:grid-cols-7 col-span-4 md:col-span-5 lg:col-span-7 md:items-center gap-4">
                  <div className="marble-score-name md:col-span-3 self-start">
                    <h4
                      className="font-heading text-h6-mobile font-h6-mobile md:text-h4 md:font-h4 text-warm-grey"
                    >
                      {data.name}
                    </h4>
                  </div>
                  <div className="marble-score-description self-start md:col-span-3">
                    <Text
                      tag="body"
                      style="text-warm-grey"
                    >
                      {data.description}
                    </Text>
                  </div>
                </div>
              </div>
            ))}
            {/* <div className="aaco-marble-score-content-detail grid grid-cols-5 md:grid-cols-8 pb-4 md:pb-6lg:pb-8 border-b-1 border-warm-grey">
              <div className="marble-score-number col-span-1 md:col-span-2 lg:col-span-1 md:self-center">
                <h4
                  className="font-heading text-h6-mobile font-h6-mobile md:text-h4 md:font-h4 text-warm-grey"
                >
                  10+
                </h4>
              </div>
              <div className="marble-content-score-detail grid lg:grid-cols-7 col-span-4 md:col-span-5 lg:col-span-7 md:items-center gap-4">
                <div className="marble-score-name md:col-span-3">
                  <h4
                    className="font-heading text-h6-mobile font-h6-mobile md:text-h4 md:font-h4 text-warm-grey"
                  >
                    Decadent
                  </h4>
                </div>
                <div className="marble-score-description md:col-span-3">
                  <Text
                    tag="body"
                    style="text-warm-grey"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Tempor commodo ullamcorper.
                  </Text>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarbleScore
